module.exports = __webpack_public_path__ + "static/media/20.d3d22be7.mp3";